<div id="{{this.propertyId}}Form" [formGroup]="this.formGroup"
    *ngIf="this.payrollInfoPeriods!=null && this.payrollInfoPeriods.length>0 ">
    <div class="row mt-15" *ngFor="let pp of this.payrollInfoPeriods;">
        <div id="{{pp.id}}Label" [ngClass]="parentElement" *ngIf="isYearPayrollField">
            <label *ngIf="isRegularPayrollField"><b>{{pp.label1}}</b> -
                {{pp.label2}}</label>
            <label *ngIf="!isRegularPayrollField">{{pp.label2}}
                <b>{{pp.label1}}</b></label>
        </div>
        <div id="{{pp.id}}Label" [ngClass]="parentElement" *ngIf="!isYearPayrollField">
            <label *ngIf="isRegularPayrollField"><b>{{pp.label1}}</b>:
                {{pp.label2}}</label>
            <label *ngIf="!isRegularPayrollField">{{pp.label2}}
                <b>{{pp.label1}}</b></label>
        </div>
        <div [ngClass]="childElement">
            <div class="input-group">                
                <div class="input-group-prepend input-box-payroll">
                    <span class="input-group-text">$</span>
                </div>
                <input id="{{pp.id}}" class="form-control input-box-payroll  text-right" type="text"
                    [readonly]="pp.disable" [required]="pp.required"
                    formControlName="{{pp.id}}" maxlength=11 minlength=1 mask="separator.0"
                    thousandSeparator="," value=""
                    [ngClass]="{'disabled-color': pp.disable}">
                <div class="input-group-append">
                    <span class="input-group-text input-box-decimal">.00</span>
                </div>
            </div>
            <!-- Show error if value is less than 100 -->
            <div *ngIf="applyMinValidator && formGroup.get(pp.id)?.invalid && formGroup.get(pp.id)?.touched"
                class="text-danger">
                <div *ngIf="formGroup.get(pp.id)?.hasError('min')">
                    Please enter an amount of at least $100
                </div>
            </div>
        </div>
    </div>
</div>